import { splitPhoneHighlightSegments } from '../../utils/phoneUiFormat';

/**
 * Snippet body with discreet cyan marks on the searched phone number.
 *
 * @param {{
 *   text?: string | null,
 *   phoneRaw?: string | null,
 *   className?: string,
 * }} props
 */
export default function HighlightedPhoneSnippet({ text = '', phoneRaw = '', className = '' }) {
  const source = String(text || '');
  if (!source) return null;
  const segments = splitPhoneHighlightSegments(source, phoneRaw);

  return (
    <p className={`text-xs leading-relaxed text-slate-400 line-clamp-3 ${className}`.trim()}>
      {segments.map((seg, i) =>
        seg.hit ? (
          <mark
            key={`ph-hit-${i}`}
            className="rounded-sm bg-cyan-500/20 px-0.5 font-semibold text-cyan-200 ring-1 ring-cyan-400/25"
          >
            {seg.text}
          </mark>
        ) : (
          <span key={`ph-txt-${i}`}>{seg.text}</span>
        ),
      )}
    </p>
  );
}
